// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/currency-dollar.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/currency-dollar'

import { Icon, type IconComponentProps } from '../icon'

export const CurrencyDollarIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
